import {toast} from "react-toastify";

const toastSuccess = (message = "") =>{
    toast.success(message);
}

const toastError = (message = "") =>{
    toast.error(message);
}

const toastInfo = (message = "") =>{
    toast.info(message);
}

export {
    toastSuccess,
    toastError,
    toastInfo
}